/**
 * Created by Tw93 on 2016/10/31.
 */

export const INPUT_ICON = "//gw.alicdn.com/tfs/TB1FZB.pwMPMeJjy1XdXXasrXXa-30-30.png";
export const CLOSE_ICON = "//gw.alicdn.com/tfs/TB1sZB.pwMPMeJjy1XdXXasrXXa-24-24.png";
export const ARROW_ICON = "//gw.alicdn.com/tfs/TB1vZB.pwMPMeJjy1XdXXasrXXa-24-24.png";




// WEBPACK FOOTER //
// ./packages/wxc-searchbar/type.js